import { DeviceStatusLabels, DeviceTypeLabels } from "./buildingDropdownConfig";

export const VIEW_COLUMNS = [
  {
    key: "deviceName",
    label: "Device Name",
    render: (device) => device?.deviceName || "",
  },
  {
    key: "deviceType",
    label: "Device Type",
    render: (device) => {
      const typeObj = DeviceTypeLabels.find(
        (option) => option.value === device?.deviceType
      );
      return typeObj ? typeObj.label : device?.deviceType || "";
    },
  },
  {
    key: "deviceStatus",
    label: "Device Status",
    render: (device) => {
      const statusObj = DeviceStatusLabels.find(
        (option) => option.value === device?.deviceStatus
      );
      return statusObj ? statusObj.label : device?.deviceStatus || "";
    },
  },
  {
    key: "deviceDomain",
    label: "Device Domain",
    render: (device) => device?.deviceDomain || "",
  },
];

export const EDIT_COLUMNS = [
  { key: "deviceName", label: "Device Name", type: "text" },
  {
    key: "deviceType",
    label: "Device Type",
    type: "select",
    options: DeviceTypeLabels,
  },
  {
    key: "deviceStatus",
    label: "Device Status",
    type: "select",
    options: DeviceStatusLabels,
  },
  { key: "deviceDomain", label: "Device Domain", type: "text" },
];
